export function applyAuthoritativeQuoteToPreview2(orderItems, quoteGroup) {
  if (!quoteGroup) return orderItems
  const quotes = new Map((quoteGroup.items || []).map(function (item) { return [String(item.item_id), item] }))
  ;(orderItems || []).forEach(function (item) {
    const quote = quotes.get(String(item.line_id || item.id || ''))
    if (!quote) return
    Object.assign(item, quote.compatibility_adjustments || { under_min_quantity_upcharge: 0 })
    item.price = Number(quote.merchandise_total || 0)
    item.technique_cost = Number(quote.decoration_total || 0)
    item.total_price = Number(quote.total || 0)
    const locations = new Map((quote.locations || []).map(function (location) {
      return [String(location.location_reference), location]
    }))
    ;(item.order_item_locations || []).forEach(function (location) {
      const key = String(location.decoration_key || location.id || location.location_reference || '')
      const priced = locations.get(key)
      if (!priced || priced.base_unit_amount === undefined || priced.base_extension === undefined) return
      location.cost = Number(priced.base_unit_amount)
      location.technique_cost = Number(priced.base_extension)
      location.authoritative_extension = Number(priced.base_extension)
      location.one_to_23_upcharge_cost = Number(quote.compatibility_adjustments && quote.compatibility_adjustments.one_to_23_upcharge_cost || 0)
    })
    if (quote.additional_locations) {
      item.additional_locations_charge = Number(quote.additional_locations.enabled || 0)
      item.additional_locations_charge_cost = Number(quote.additional_locations.unit_rate || 0)
      item.authoritative_additional_locations = JSON.parse(JSON.stringify(quote.additional_locations))
    }
  })
  return orderItems
}
